import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, distinctUntilChanged, switchMap, combineLatest, map, take } from 'rxjs';
import { CollapseContainer, CollapseEntry } from './core/collapse-container.model';
import { CollapseItem } from '../../../../../../components/collapse-list/model/collapse.model';

@Component({
  selector: 'cms-collapse-container',
  templateUrl: './cms-collapse-container.component.html',
  styleUrl: './cms-collapse-container.component.scss',
  standalone: false,
})
export class CollapseContainerComponent {
  @ViewChild('container') container!: ElementRef;

  areAllOpen = false;

  components$: Observable<CollapseItem[]> = this.componentData.data$.pipe(
    switchMap((data: CollapseContainer) =>
      combineLatest(
        (data?.items ?? '').split(' ').map((item, i) =>
          this.cmsService.getComponentData<any>(item).pipe(
            distinctUntilChanged(),
            map(item => this.normalizeCollapseEntryToItem(item, i)),
          ),
        ),
      ),
    ),
  );

  constructor(
    public componentData: CmsComponentData<any>,
    protected cmsService: CmsService,
    private cdr: ChangeDetectorRef,
  ) {}

  onToggleAll(isChecked: boolean): void {
    this.areAllOpen = isChecked;
    this.components$ = this.components$.pipe(
      map(components => components.map(item => ({ ...item, isOpen: isChecked }))),
    );
  }

  private normalizeCollapseEntryToItem(entry: CollapseEntry, index: number): CollapseItem {
    return {
      id: index.toString(),
      title: entry?.title,
      isOpen: entry?.isActive === 'true',
      content: entry?.content,
    };
  }

  handleToggle() {
    setTimeout(() => {
      this.components$.pipe(take(1)).subscribe(items => {
        const $container = this.container.nativeElement as HTMLDivElement;
        const $opededItems = $container.querySelectorAll(`.collapse-item.is-open`);
        this.areAllOpen = $opededItems.length === items.length;
        this.cdr.detectChanges();
      });
    }, 50);
  }
}
